<template>
    <div class="nodata">
        <img :src="nodataImg" alt="">
        <div class="textcolor">{{language.failed_to_load}}</div>
    </div>
  </template>
  <script>
    import { h5list} from "../../../utils/api";
    import { getLangue } from "@/utils/language.js"
    import  feedbackDetails  from "../feedbackDetails/index.vue"
    export default {
        props: [],
        components: {
            feedbackDetails
        },
        data() {
        return {
            getDataLoading:false,
            language: getLangue(),
            imagesList:[],
            showImg:false,
            loading:false,
            finished:false,
            startPosition:0,
            pageDate:{
                page:1,
                limit:10
            },
            list:[],
            hasData:true,
            nodataImg:require('../../../static/img/404.png'),
            showdetails:false
        };
        },
        created(){

        },
        methods: {

        },
    };
  </script>
  <style lang="scss" scoped>
  .nodata{
    height: 100%;
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top:0px;
    left:0;
    z-index: 1111;
    img{
        width: 260px;
    }
    div{
        font-size: 18px;
        text-align: center;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/view/404/index.vue